import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: "season-grid",
    "data-testid": `${_ctx.testid}-custom-picker-season`
  }, [
    _createVNode(_component_v_list, { class: "season-list-items" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasons, (season) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: season.value,
            class: _normalizeClass(["season-list-item", {
          selected: _ctx.isSeasonSelected(season),
          disabled: _ctx.isDisabled(season),
          current: _ctx.isCurrentSeason(season),
        }]),
            disabled: _ctx.isDisabled(season),
            onClick: ($event: any) => (!_ctx.isDisabled(season) && _ctx.$emit('select', season))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.getLabel(season.value)), 1)
            ]),
            _: 2
          }, 1032, ["class", "disabled", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}